(function () {
  var STORAGE_KEY = 'wishlist_product_ids';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(ids) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  }

  function isInWishlist(productId) {
    return getWishlist().indexOf(String(productId)) !== -1;
  }

  function toggleWishlist(productId) {
    var ids = getWishlist();
    var idStr = String(productId);
    var index = ids.indexOf(idStr);

    if (index === -1) {
      ids.push(idStr);
    } else {
      ids.splice(index, 1);
    }

    saveWishlist(ids);
    updateAllButtons();
    updateCountBadge();
    return index === -1; // true = added, false = removed
  }

  function updateAllButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.dataset.productId;
      btn.classList.toggle('is-active', isInWishlist(id));
    });
  }

  function updateCountBadge() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function renderDrawer() {
    var ids = getWishlist();
    var container = document.getElementById('WishlistDrawerItems');
    if (!container) return;

    if (ids.length === 0) {
      container.innerHTML = '<p class="cart-drawer__empty">' + (window.wishlistEmptyText || 'Your wishlist is empty') + '</p>';
      return;
    }

    container.innerHTML = '<p class="cart-drawer__empty">Loading...</p>';

   

    // Since storefront has no "get product by id" endpoint, we instead rely on
    // data attributes stored alongside the id (see addToWishlistFull below).
    var itemsData = JSON.parse(localStorage.getItem('wishlist_items_data') || '{}');
    var html = '';

ids.forEach(function (id) {
  var item = itemsData[id];
  if (!item) return;
  html += '' +
    '<div class="cart-drawer__item">' +
      '<a href="' + item.url + '">' +
        '<img src="' + item.image + '" alt="' + item.title + '" width="80" height="80" loading="lazy">' +
      '</a>' +
      '<div class="cart-drawer__item-info">' +
        '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.title + '</a>' +
        '<p class="cart-drawer__item-price">' + item.price + '</p>' +
        '<button type="button" class="cart-drawer__item-add-cart" data-wishlist-add-to-cart="' + item.variantId + '">' + (window.wishlistAddToCartText || 'Add to cart') + '</button>' +
      '</div>' +
      '<button type="button" class="cart-drawer__item-remove" data-wishlist-remove="' + id + '" aria-label="Remove">' +
        '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M1 1L13 13M13 1L1 13" stroke="#010101" stroke-width="1.3" stroke-linecap="round"/>' +
        '</svg>' +
      '</button>' +
    '</div>';
});

    container.innerHTML = html || '<p class="cart-drawer__empty">Your wishlist is empty</p>';
  }

  function saveItemData(productId, data) {
    var itemsData = JSON.parse(localStorage.getItem('wishlist_items_data') || '{}');
    itemsData[String(productId)] = data;
    localStorage.setItem('wishlist_items_data', JSON.stringify(itemsData));
  }

  function removeItem(productId) {
    var ids = getWishlist();
    var idStr = String(productId);
    var index = ids.indexOf(idStr);
    if (index !== -1) {
      ids.splice(index, 1);
      saveWishlist(ids);
      updateAllButtons();
      updateCountBadge();
      renderDrawer();
    }
  }

function addToCart(variantId, btnEl) {
  btnEl.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(function (res) { return res.json(); })
    .then(function () {
      btnEl.disabled = false;

      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        });

      fetch('/?section_id=cart-drawer-items')
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newItems = doc.getElementById('CartDrawerItems');
          var currentItems = document.getElementById('CartDrawerItems');
          if (newItems && currentItems) {
            currentItems.innerHTML = newItems.innerHTML;
          }
        });
    })
    .catch(function () {
      btnEl.disabled = false;
    });
}


  document.addEventListener('DOMContentLoaded', function () {
    updateAllButtons();
    updateCountBadge();

    document.addEventListener('click', function (e) {
      var toggleBtn = e.target.closest('[data-wishlist-toggle]');
      var removeBtn = e.target.closest('[data-wishlist-remove]');
      var wishlistOpenBtn = e.target.closest('[data-wishlist-open]');
      var closeBtn = e.target.closest('[data-wishlist-close]');
var addToCartBtn = e.target.closest('[data-wishlist-add-to-cart]'); 

      if (toggleBtn) {
        e.preventDefault();
        var productId = toggleBtn.dataset.productId;

  

        saveItemData(productId, {
  title: toggleBtn.dataset.productTitle,
  image: toggleBtn.dataset.productImage,
  price: toggleBtn.dataset.productPrice,
  url: toggleBtn.dataset.productUrl,
  variantId: toggleBtn.dataset.variantId
});

        toggleWishlist(productId);
      }

      if (removeBtn) {
        removeItem(removeBtn.dataset.wishlistRemove);
      }

      if (wishlistOpenBtn) {
        e.preventDefault();
        renderDrawer();
        var drawer = document.getElementById('WishlistDrawer');
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      if (closeBtn) {
        var wDrawer = document.getElementById('WishlistDrawer');
        wDrawer.classList.remove('is-open');
        wDrawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }

      if (addToCartBtn) {
  var variantId = addToCartBtn.dataset.wishlistAddToCart;
  addToCart(variantId, addToCartBtn);
}
    });
  });
})();